import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Nom du champ piège que l'API vérifie sur `/api/contact` et `/api/newsletter`
 * (`CHAMP_PIEGE`, apps/api/src/demandes/publiques.routes.ts). Rempli, la
 * requête réussit et n'écrit rien.
 */
export const CHAMP_PIEGE = 'site_web';
/**
 * Champ piège d'un formulaire public : hors de l'écran (`.piege`, feuille du
 * thème), caché aux lecteurs d'écran, hors de l'ordre de tabulation et sans
 * remplissage automatique — une personne ne le voit ni ne le remplit, un robot
 * qui remplit tout le remplit. Même forme que celui des viewing rooms
 * (`salle/rendre.tsx`). Libellé neutre : il ne doit pas se désigner comme piège.
 */
export function ChampPiege({ ctx }) {
    return (_jsx("div", { className: "piege", "aria-hidden": "true", children: _jsxs("label", { children: [ctx.langue === 'fr' ? 'Site web' : 'Website', _jsx("input", { type: "text", name: CHAMP_PIEGE, tabIndex: -1, autoComplete: "off" })] }) }));
}
//# sourceMappingURL=piege.js.map